module.exports = __webpack_public_path__ + "static/media/JeeMains.1ab89b18.jpg";